export const RUPEE_SIGN = '₹'
export const DEFAULT_PETROL = 101.94
export const DEFAULT_DIESEL = 87.89
export const UNIT = '/Ltr'
export const PETROL = 'Petrol'
export const DIESEL = 'Diesel'
export const DESERT_LEFT = 'https://acko-cms.ackoassets.com/fuel_dessert_left_7c8f772397.svg'
export const DESERT_RIGHT = 'https://acko-cms.ackoassets.com/fuel_dessert_right_c94046927b.svg'
